/**
 * iOS installed-PWA detection. Two signals, either one sufficient:
 * `navigator.standalone` is Safari/iOS-only (not in the DOM lib types, hence
 * the cast) and is the most reliable one there; `display-mode: standalone`
 * is the cross-browser media query, true on Android/desktop installs too.
 * Used to decide whether the code-login path should be offered first (an
 * iOS PWA can never receive a magic link — it opens in Safari, not here).
 */
export function isStandalonePwa(): boolean {
  if (typeof window === "undefined") return false;
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone;
  if (iosStandalone === true) return true;
  return typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches;
}
